// export const imgPath = '../../Components/Images'
export const ErrorSource = "CURONEXTPORTAL"
export const EmailOTPTeamName = "INAPP"